import MaterialDialogHeader from '../../../components/MaterialDialogHeader';
import { ComponentProps } from 'react';
import { ExternalMediaMedialinkGeoGebra } from '../../../../../api/medialink';
import MaterialModal from './MaterialModal';
import { useTranslation } from 'react-i18next';

interface Props {
  id: string;
  headerProps: Pick<ComponentProps<typeof MaterialDialogHeader>, 'title' | 'tags' | 'titleTooltip'>;
  medialink: ExternalMediaMedialinkGeoGebra;
}

function GeogebraModal({ headerProps, id, medialink }: Props) {
  const { t } = useTranslation();
  const { geogebra } = medialink.externalMedia;

  const language = geogebra?.language === 1 ? 'fr' : 'nl';

  const url = `https://www.geogebra.org/material/iframe/id/${medialink.externalMedia.embedId}/width/${medialink.externalMedia.width}/height/${medialink.externalMedia.height}/border/888888/smb/${geogebra.menuBar}/stb/${geogebra.toolbar}/stbh/${geogebra.toolbarHelp}/ai/${geogebra.inputbar}/asb/${geogebra.stylebar}/sri/${geogebra.resetIcon}/rc/${geogebra.rightClick}/ld/${geogebra.labelDragging}/sdz/${geogebra.shiftDrag}/ctl/false?lang=${language}`;

  return (
    <MaterialModal id={id} headerProps={headerProps} aria-label={t('PAGES.TOC_LEVEL.MODALS.GEOGEBRA.A11Y_LABEL')}>
      <iframe
        role="presentation"
        src={url}
        title={medialink.name}
        allow="fullscreen"
        width={medialink.externalMedia.width || '100%'}
        height={medialink.externalMedia.height || '100%'}
        frameBorder="0"
      />
    </MaterialModal>
  );
}

export default GeogebraModal;
